import React from "react"
import "./PercentageField.css"

const PercentageField = ({ field, form: { touched, errors }, ...props }) => {
  let status = "default"
  if (touched[field.name] && errors[field.name]) {
    status = "has-error"
  } else if (touched[field.name] && field.value && !errors[field.name]) {
    status = "is-fixed"
  }
  return (
    <div className={`PercentageField ${status}`}>
      <input {...field} {...props} placeholder="0" />
      <span className="percentage">%</span>
      {touched[field.name] &&
        errors[field.name] && (
          <div className="error-message">{errors[field.name]}</div>
        )}
    </div>
  )
}

export default PercentageField
